import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import useCurrentUser from '../../digital-courses/current-user/useCurrentUser';
import { t } from '../../i18n';
import getCampaignPromocode from '../../digital-courses/getCampaignPromocode';
import UrlTo from '../../url-to';
import './styles.scss';
import CountdownTimer from './countdown-timer';

const CoursesPromocodesBanner = () => {
  const { isAuthenticated } = useCurrentUser();

  const automaticPromocode = useMemo(getCampaignPromocode, []);

  // BEGIN: Delete this code after Halloween campaign end
  const now = new Date();
  const campaignBegin = new Date('2023-10-27T10:00:00+02:00');
  const campaignEnd = new Date('2023-10-29T10:00:00+01:00');
  const isCampaignOngoing = now >= campaignBegin;
  const [timeLeft, setTimeLeft] = useState(Math.max(0, campaignBegin - new Date()));

  useEffect(() => {
    const interval = setInterval(() => {
      if (isCampaignOngoing) {
        setTimeLeft(Math.max(0, campaignEnd - new Date()));
      } else {
        setTimeLeft(Math.max(0, campaignBegin - new Date()));
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [isCampaignOngoing]);
  // END: Delete this code after Halloween campaign end

  if (isAuthenticated) {
    return (
      <div className="promocodes-banner">
        {t('DIGITAL_COURSES.SEE_YOUR_COURSES')}
        <Link to={UrlTo.coursesProfile()}>{t('DIGITAL_COURSES.NEW_COURSE_BANNER_CLICK_HERE')}</Link>
      </div>
    );
  }

  if (automaticPromocode === 'AGRIA20') {
    return (
      <div className="promocodes-banner">
        Halloj bästa Agria-kund! Din rabatt på 20% dras automatiskt i kassan vid betalning 😊
      </div>
    );
  }

  // BEGIN: Delete this code after Halloween campaign end
  if (now < campaignEnd) {
    return (
      <div className="promocodes-banner promocodes-banner--orange">
        <p style={{ fontSize: '50px', fontWeight: 'bold', marginTop: '2rem', color: '#ffffff' }}>
          {'EN LÄSKIGT BRA DEAL! 👻'}
        </p>
        <p style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '1rem', color: '#ffffff' }}>
          25% på alla digitala kurser i helgen.
        </p>
        {isCampaignOngoing ? (
          <p style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '1.5rem', color: '#ffffff' }}>
            Erbjudandet gäller endast t.o.m. söndag 29/10 kl. 10:00.
          </p>
        ) : (
          <p style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '1.5rem', color: '#ffffff' }}>
            Erbjudandet börjar gälla om:
          </p>
        )}
        <CountdownTimer timeLeft={timeLeft} />
      </div>
    );
  }
  // END: Delete this code after Halloween campaign end

  return null;
};

export default CoursesPromocodesBanner;
